import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DashSidebar from "../components/Dashboard/DashSideBar";
import DashProfile from "../components/Dashboard/DashProfile";
import DashTournaments from "../components/Dashboard/DashTournaments";
import DashTeams from "../components/Dashboard/DashTeams";
import DashRosters from "../components/Dashboard/DashRosters";
import DashTournamentsDetails from "../components/Dashboard/DashTournamentsDetails";

export default function Dashboard() {
  const location = useLocation();
  const [tab, setTab] = useState("");
  const [tournamentId, setTournamentId] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get("tab");
    if (tabFromUrl) {
      setTab(tabFromUrl);
      if (tabFromUrl.startsWith("tournamentsDetails/")) {
        const id = tabFromUrl.split("/")[1];
        setTournamentId(id);
      } else {
        setTournamentId(null);
      }
    }
  }, [location.search]);

  const handleTabChange = (tabName) => {
    setTab(tabName);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div style={{ minWidth: "220px" }}>
        <DashSidebar activeTab={tab} onTabChange={handleTabChange} />
      </div>
      <div className="flex">
        {tab === "profile" && <DashProfile />}
        {tab === "tournaments" && <DashTournaments />}
        {tab === "teams" && <DashTeams />}
        {tab === "rosters" && <DashRosters />}
        {tab.startsWith("tournamentsDetails/") && (
          <DashTournamentsDetails id={tournamentId} />
        )}
      </div>
    </div>
  );
}
